import React, { FC } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import LocationOverview from '../../pages/mobilbase/LocationOverview';
import LocationSearch from '../../pages/mobilbase/LocationSearch';
import DeviceOverview from '../../pages/mobilbase/DeviceOverview';
import Checkout from '../../pages/mobilbase/Checkout';
import DeviceLog from '../../pages/mobilbase/DeviceLog';
import DeviceManage from '../../pages/mobilbase/DeviceManage';
import { RouteLocationProps, CheckoutLocationProps } from '../../routes/mobilbase';

interface Props {
  changePage: (historyState: RouteLocationProps) => void;
  changePageCheckout: (historyState: CheckoutLocationProps) => void;
}

const RouteHandler: FC<Props> = ({ changePage, changePageCheckout }) => (
  <Switch>
    <Route exact path={`/mobilbase`}>
      <Redirect to={`/mobilbase/plads`} />
    </Route>
    <Route exact path={`/mobilbase/plads`}>
      <LocationOverview navFunc={changePage} />
    </Route>
    <Route exact path={`/mobilbase/plads/search`}>
      <LocationSearch navFunc={changePageCheckout} />
    </Route>
    <Route exact path={`/mobilbase/plads/automat`}>
      <DeviceOverview navFunc={changePage} />
    </Route>
    <Route exact path={`/mobilbase/plads/automat/checkout`}>
      <Checkout />
    </Route>
    <Route path={`/mobilbase/plads/automat/log`}>
      <DeviceLog />
    </Route>
    <Route path={`/mobilbase/plads/automat/administrer`}>
      <DeviceManage />
    </Route>
    <Route>
      <div>Siden bliv ikke fundet</div>
    </Route>
  </Switch>
);

export default RouteHandler;